import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5597055c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sticky-column" }
const _hoisted_2 = {
  class: "is-flex is-justify-content-start",
  style: {"gap":"1em"}
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("td", _hoisted_1, [
      _createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.downloadFile({ fileUrl: _ctx.fileData.download_url, fileName: _ctx.fileData.file_name })), ["prevent"])),
        target: "_blank"
      }, _toDisplayString(_ctx.fileData.file_name), 1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(_ctx.fileData.file_description), 1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(_ctx.fileData.file_type), 1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(_ctx.formatFileSize(_ctx.fileData.file_size)), 1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(_ctx.fileData.upload_time), 1)
    ]),
    (_ctx.getAccessType == 'manager' || _ctx.getAccessType == 'vet')
      ? (_openBlock(), _createElementBlock("td", {
          key: 0,
          class: _normalizeClass({ 'inactive-status': _ctx.fileData.status === _ctx.$t('FilesData.TK_Inactive') })
        }, [
          _createElementVNode("div", null, _toDisplayString(_ctx.fileData.status), 1)
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.getAccessType == 'manager')
      ? (_openBlock(), _createElementBlock("td", {
          key: 1,
          class: _normalizeClass({ 'inactive-status': _ctx.fileData.status === _ctx.$t('FilesData.TK_Inactive') })
        }, [
          _createElementVNode("div", null, _toDisplayString(_ctx.fileData.status_date), 1)
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("td", null, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.editingAppointment &&
                 (_ctx.getAccessType == 'manager' || _ctx.getAccessType == 'vet' || _ctx.fileData.file_id == 0) &&
                 _ctx.fileData.status != _ctx.$t('FilesData.TK_Inactive'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("button", {
                type: "button",
                class: "button is-danger is-small",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.remove(_ctx.fileData, _ctx.$t)))
              }, _toDisplayString(_ctx.$t('General.Delete')), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.editingAppointment &&
                 (_ctx.getAccessType == 'manager' || _ctx.getAccessType == 'vet' || _ctx.fileData.file_id == 0) &&
                 _ctx.fileData.status != _ctx.$t('FilesData.TK_Active'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("button", {
                type: "button",
                class: "button is-danger is-small",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.reactivate(_ctx.fileData, _ctx.$t)))
              }, _toDisplayString(_ctx.$t('General.Reactivate')), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}